import '../src/Global.styles.css';
import { ThemeProvider } from '@emotion/react';
import { HashRouter } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/system';
import Screens from './screens';
import Theme from './Theme.styles';
import { Provider } from 'react-redux';
import 'react-image-crop/dist/ReactCrop.css';
import { store } from './store/store';
import Message from './components/Message/Message.component';

function App() {
  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <Provider store={store}>
          <Message />
          <ThemeProvider theme={Theme}>
            {/* <Styles /> */}
            <HashRouter>
              <Screens />
            </HashRouter>
          </ThemeProvider>
        </Provider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
